<template>
  <a-col :span="8" class="card">
    <a-row>
      <a-col :span="14" class="avatar">
        <div class="avatar__wrapper">
          <template v-if="model.img">
            <a-spin :spinning="!!model.img" />
            <img :src="model.img" alt="" />
          </template>
          <template v-else>
            <img class="skeleton" src="@/assets/icons/camera.svg" alt="" />
          </template>
        </div>
      </a-col>
      <a-col :span="10" class="change-button">
        <button-primary v-if="showChangeButton" @click.stop="onLeaderChange"
          >Сменить</button-primary
        >
        <delete-button
          v-if="showDeleteButton"
          :loading="isLoading"
          @delete="handleDelete"
        />
      </a-col>
    </a-row>
    <a-row class="person">
      <div class="person__fullname">
        {{ model.fullname }}
      </div>
      <div class="person__position">
        {{ model.isLeader ? 'Руководитель проекта' : model.position }}
      </div>
      <div class="person__email">{{ model.email }}</div>
      <div class="person__phone">{{ model.phone }}</div>
    </a-row>

    <a-divider />

    <a-row class="tasks">
      <a-col :span="8" class="tasks__total">
        <div>Всего задач</div>
        <div class="count">{{ tasksTotal }}</div>
      </a-col>
      <a-divider type="vertical" />
      <a-col :span="8" class="tasks__expired">
        <div>Просрочено</div>
        <div class="count">{{ model.incompleteOverdueCount }}</div>
      </a-col>
      <a-divider type="vertical" />
      <a-col :span="8" class="tasks__done">
        <div>Выполнено</div>
        <div class="count">
          {{ model.completedCount + model.completedOverdueCount }}
        </div>
      </a-col>
    </a-row>
  </a-col>
</template>

<script setup>
  import { computed, reactive, ref } from 'vue';
  import ButtonPrimary from '@/views/portal/components/UI/ButtonPrimary.vue';
  import {
    USER_ROLE_ADMINISTRATOR,
    USER_ROLE_LEADER,
  } from '@/api/models/UserRole';
  import { useRoute } from 'vue-router';
  import DeleteButton from '@/components/projects/team/TeamMember/DeleteButton.vue';
  import { useApi } from '@/api/use-api';

  const props = defineProps({
    executor: Object,
    isMyProject: {
      type: Boolean,
      default: true,
    },
  });
  const emit = defineEmits(['update', 'change-leader']);
  const route = useRoute();
  const api = useApi();
  const isLoading = ref(false);

  const getAvatarUrl = (avatar) =>
    avatar ? `/api/v1/attachment/${avatar}` : null;

  const model = reactive({
    id: props.executor.id,
    isLeader: props.executor.isLeader,
    img: getAvatarUrl(props.executor.avatar),
    fullname: props.executor.fullName,
    position: props.executor.position,
    email: props.executor.email,
    phone: props.executor.phone,
    completedCount: props.executor.completedCount,
    completedOverdueCount: props.executor.completedOverdueCount,
    incompleteCount: props.executor.incompleteCount,
    incompleteOverdueCount: props.executor.incompleteOverdueCount,
  });

  const tasksTotal = computed(() => {
    return (
      model.completedCount +
      model.completedOverdueCount +
      model.incompleteCount +
      model.incompleteOverdueCount
    );
  });

  const showChangeButton = computed(() => {
    return (
      props.isMyProject &&
      model.isLeader &&
      route.meta.role === USER_ROLE_ADMINISTRATOR
    );
  });

  const showDeleteButton = computed(() => {
    return (
      props.isMyProject &&
      route.meta.role === USER_ROLE_LEADER &&
      tasksTotal.value === 0
    );
  });

  const onLeaderChange = () => {
    emit('change-leader');
  };

  const handleDelete = async () => {
    try {
      isLoading.value = true;
      await api.projectExecutor.remove(model.id);
      emit('update');
    } catch (error) {
      console.log(error);
    } finally {
      isLoading.value = false;
    }
  };
</script>

<style lang="scss" scoped>
@use "@/assets/styles/_colors.scss" as *;

  * {
    font-family: 'Nunito Sans', sans-serif;
  }

  .card {
    background-color: $color-bg-secondary-grey;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    max-height: 389px;
    max-width: 325px;
    overflow: hidden;
    padding: 20px;
    user-select: none;
    width: 325px;
    height: 389px;

    .btn.btn-primary {
      padding: 6px 12px;
    }
    .change-button {
      display: flex;
      align-items: start;
      justify-content: flex-end;
    }

    .avatar {
      &__wrapper {
        border-radius: 50%;
        background-color: $color-bg-primary-white;
        overflow: hidden;
        padding: 2rem;
        position: relative;
        height: 5rem;
        width: 5rem;

        img {
          margin: auto;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 100%;
        }

        .skeleton {
          width: auto;
        }
      }
    }

    .person {
      color: $color-bg-status-new;
      display: flex;
      flex-direction: column;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      margin-top: 20px;
      row-gap: 20px;

      &__fullname {
        color: $color-text-primary;
        font-weight: 700;
        font-size: 16px;
        line-height: 22px;
      }
    }

    .tasks {
      flex-wrap: nowrap;
      font-weight: 400;
      font-size: 14px;
      line-height: 20px;
      justify-content: center;
      text-align: center;

      .count {
        color: $color-text-secondary-1;
        font-weight: 700;
      }
    }

    .ant-divider {
      border-color: $color-bg-primary-white;

      &.ant-divider-vertical {
        height: 50px;
      }
    }
  }
</style>
